<template>
  <input
    class="postcode-input"
    :class="$i18n.locale"
    type="text"
    :disabled="disabled"
    v-model="formattedValue"
    :placeholder="placeholder"
    @input="handleInput"
    @blur="handleBlur"
    :maxlength="maxLength"
  />
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { POSTCODE_ERROR_TYPE } from '@/enum'
// import导入组件工具等
export default {
  props: {
    postcode: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    showValidation: {
      type: Boolean,
      default: false, // 是否显示验证状态
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isUpdatePostcode: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formattedValue: '',
    }
  },
  created() {},
  // 组件方法
  methods: {
    ...mapMutations(['SET_POSTCODE']),
    handleInput(event) {
      let value = event.target.value
      let cleanValue

      if (this.userIpCountry === 'US') {
        // 美国邮编：只允许数字，最多5位
        cleanValue = value.replace(/[^0-9]/g, '')

        // 限制最大长度为5位
        if (cleanValue.length > 5) {
          cleanValue = cleanValue.substring(0, 5)
        }

        this.formattedValue = cleanValue
        this.$emit('update:postcode', cleanValue)
      } else {
        // 加拿大邮编：允许数字和字母，最多6位，3位后加空格
        cleanValue = value.replace(/[^a-zA-Z0-9]/g, '')

        // 限制最大长度为6位
        if (cleanValue.length > 6) {
          cleanValue = cleanValue.substring(0, 6)
        }

        // 格式化：在第3位后添加空格
        if (cleanValue.length > 3) {
          this.formattedValue = cleanValue.substring(0, 3) + ' ' + cleanValue.substring(3)
        } else {
          this.formattedValue = cleanValue
        }

        // 触发父组件更新
        this.$emit('update:postcode', cleanValue.toUpperCase())
      }

      // 触发验证事件
      this.$emit('validate', this.validate(cleanValue))
    },

    handleBlur() {
      this.$emit('blur', this.validate())
    },

    validate(cleanValue) {
      cleanValue = cleanValue === undefined || cleanValue === null ? this.postcode : cleanValue

      if (!cleanValue) {
        return {
          isValid: false,
          message: this.$t('primer.empty'),
          errorType: POSTCODE_ERROR_TYPE.EMPTY,
        }
      }

      if (this.userIpCountry === 'US') {
        // 美国邮编：必须是5位数字
        if (!/^\d{5}$/.test(cleanValue)) {
          return {
            isValid: false,
            message: this.$t('code.invalid'),
            errorType:
              cleanValue.length < 5
                ? POSTCODE_ERROR_TYPE.INVALID_LENGTH
                : POSTCODE_ERROR_TYPE.INVALID_FORMAT,
          }
        }
      } else {
        // 加拿大邮编：必须是6位，格式为字母数字字母数字字母数字
        if (!/^[A-Za-z]\d[A-Za-z]\d[A-Za-z]\d$/.test(cleanValue)) {
          return {
            isValid: false,
            message: this.$t('code.invalid'),
            errorType:
              cleanValue.length < 6
                ? POSTCODE_ERROR_TYPE.INVALID_LENGTH
                : POSTCODE_ERROR_TYPE.INVALID_FORMAT,
          }
        }
      }

      // 填写正确 记录邮编，支付成功后记录邮编
      this.isUpdatePostcode && this.SET_POSTCODE(cleanValue)

      return {
        isValid: true,
        message: '',
      }
    },

    // 公开方法，供父组件调用
    validatePostcode() {
      return this.validate()
    },
  },
  // 计算属性
  computed: {
    ...mapState({
      userIpCountry: (state) => state.user.userIpCountry,
    }),
    maxLength() {
      return this.userIpCountry === 'US' ? 5 : 7 // 美国5位，加拿大7位（含空格）
    },
  },
  // 侦听器
  watch: {
    postcode: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          if (this.userIpCountry === 'US') {
            // 美国邮编：只保留数字，最多5位
            let cleanValue = newVal.replace(/[^0-9]/g, '').substring(0, 5)
            this.formattedValue = cleanValue
          } else {
            // 加拿大邮编：清理并格式化初始值
            let cleanValue = newVal.replace(/[^a-zA-Z0-9]/g, '').substring(0, 6)
            if (cleanValue.length > 3) {
              this.formattedValue = cleanValue.substring(0, 3) + ' ' + cleanValue.substring(3)
            } else {
              this.formattedValue = cleanValue
            }
          }
        } else {
          this.formattedValue = ''
        }
      },
    },
  },
  // import的组件需要声明
  components: {},
}
</script>

<style lang="less" scoped>
.postcode-input {
  width: 100%;
  color: rgba(52, 58, 63, 1);
  font-size: 15px;
  font-weight: 500;
  font-family: 'roboto-medium';
  &::placeholder {
    color: rgba(135, 141, 150, 1);
    font-weight: 400;
    font-family: 'roboto-regular';
  }
  &.AR {
    &::placeholder {
      font-size: 13px;
    }
  }
}
</style>
